import { Box } from "@material-ui/core"
import PropTypes from "prop-types"

import Embedded from "./Components/Embedded"
import Listing from "./Components/Listing"
import useStyles from "./styles"

const Step5 = ({
  tabValue,
  areasOfInterest,
  areasOfExpertise,
  areasOfExperience,
  entityInfo = {},
}) => {
  const classes = useStyles()

  return (
    <Box className={classes.container}>
      {tabValue === 1 ? (
        <Listing
          areasOfExperience={areasOfExperience}
          areasOfExpertise={areasOfExpertise}
          areasOfInterest={areasOfInterest}
          entityInfo={entityInfo}
        />
      ) : (
        <Embedded
          areasOfExperience={areasOfExperience}
          areasOfExpertise={areasOfExpertise}
          areasOfInterest={areasOfInterest}
        />
      )}
    </Box>
  )
}

Step5.propTypes = {
  tabValue: PropTypes.number,
  areasOfInterest: PropTypes.array,
  areasOfExpertise: PropTypes.array,
  areasOfExperience: PropTypes.array,
  entityInfo: PropTypes.object,
}

export default Step5
